export default __webpack_public_path__ + "static/media/testimonials.11aea40f.png";